const available_currencies_options = [
  { label: 'HUF', value: 'HUF' },
  { label: 'SEK', value: 'SEK' },
  { label: 'GBP', value: 'GBP' },
  { label: 'CZK', value: 'CZK' },
  { label: 'EUR', value: 'EUR' },
  { label: 'PLN', value: 'PLN' },
  { label: 'RON', value: 'RON' },
  { label: 'BGN', value: 'BGN' },
]

export default available_currencies_options
